import { testimonials } from '@/mocks/homeData';
import { useState } from 'react';

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-12 md:py-16 px-4 md:px-8 bg-background-50">
      <div>
        <h2 className="text-center text-lg md:text-xl font-bold text-secondary-900 tracking-wide mb-10 md:mb-12">
          O QUE NOSSOS CLIENTES DIZEM
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <article
              key={testimonial.id}
              className="text-center px-2"
              onMouseEnter={() => setActiveIndex(index)}
            >
              {/* Quote marks */}
              <div className="text-primary-300 text-4xl md:text-5xl font-serif leading-none mb-2">
                &ldquo;
              </div>

              {/* Text */}
              <p className="text-sm text-foreground-700 leading-relaxed mb-4 italic">
                {testimonial.text}
              </p>

              {/* Stars */}
              <div className="flex items-center justify-center gap-0.5 mb-3">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-400">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                ))}
              </div>

              {/* Name */}
              <p className="text-sm font-semibold text-secondary-900">{testimonial.name}</p>
            </article>
          ))}
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`w-2.5 h-2.5 rounded-full transition-colors ${
                index === activeIndex ? 'bg-primary-500' : 'bg-background-300'
              }`}
              aria-label={`Ver depoimento ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}